/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useState, useEffect } from 'react';
import moment from 'moment';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Autocomplete,
} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { toast } from 'react-toastify';
import { DatePicker } from '@mui/x-date-pickers';
import AppConst from '../AppLayout/const';
// API
import { getTeamV4Filter } from '../../api/filterOptionsApi';
import { getProductPresentationExtractor } from '../../api/productPresentationApi';
import useStore from '../../states/store';
// Helper Functions
import { filterTeamV4Options } from '../../helpers/filterFunctions';

export default function ProductPresentationModal() {
  const auth = useStore((state) => state.auth);
  const { toggleModal, onToggleModal } = useContext(AppConst.AppContext);
  const [toggle, setToggle] = useState(false);

  const defaultFilter = {
    department: { label: 'ALL', value: null },
    date_from: moment().startOf('month').format('YYYY-MM-DD'),
    date_to: moment().endOf('month').format('YYYY-MM-DD'),
  };

  const [filterForm, setFilterForm] = useState(defaultFilter);
  const [departmentOptions, setDepartmentDrowndown] = useState([]);

  const handleChangeFilter = (e, row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };

  const handleChangeDate = (row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };

  const loadDepartmentDropdown = async () => {
    const request = {
      keyword: '',
    };
    const reponse = await getTeamV4Filter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      let newDropdownValue;
      const dropdownValue = filterTeamV4Options(data);

      if (auth?.designation === 'SAM' || auth?.designation === 'KASM') {
        newDropdownValue = dropdownValue;
      } else {
        newDropdownValue = [{ label: 'ALL', value: null }, ...dropdownValue];
      }
      setDepartmentDrowndown(newDropdownValue);

      if (dropdownValue.length < 2) {
        setFilterForm((prevState) => ({
          ...prevState,
          department: dropdownValue[0],
        }));
      } else {
        setFilterForm((prevState) => ({
          ...prevState,
          department: { label: 'ALL', value: null },
        }));
      }
    }
  };

  useEffect(() => {
    if (toggleModal?.url === 'report/product_presentaion') {
      setToggle(true);
      loadDepartmentDropdown();
    }
  }, [toggleModal]);

  const handleExport = async () => {
    try {
      toast.loading('Processing request please wait ...');

      const request = {
        department: filterForm?.department?.value,
        date_from: moment(filterForm?.date_from).format('YYYY-MM-DD'),
        date_to: moment(filterForm?.date_to).format('YYYY-MM-DD'),
      };

      const res = await getProductPresentationExtractor(request);

      const { code, result, message } = res.data.response;
      if (code !== '200') {
        throw Object.assign(new Error(message), { code: 402 });
      }
      toast.dismiss();

      window.location.href = result;
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  const handleCancel = () => {
    onToggleModal(null);
    setToggle(false);
  };

  return (
    <Dialog open={toggle} onClose={handleCancel} maxWidth='sm' fullWidth>
      <DialogTitle>Product Presentation Report</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2} mb={1}>
          <Grid md={12}>
            <Autocomplete
              id='department'
              disableClearable
              fullWidth
              options={departmentOptions}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='Deparment' />}
              size='small'
              value={filterForm?.department}
              onChange={(e, newValue) => handleChangeFilter(e, newValue, 'department')}
              sx={{ backgroundColor: '#fff' }}
            />
          </Grid>
          <Grid lg={6}>
            <DatePicker
              label='from'
              views={['month', 'day', 'year']}
              value={filterForm?.date_from}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => (
                <TextField {...params} label='From' size='small' fullWidth />
              )}
              onChange={(newValue) => handleChangeDate(newValue, 'date_from')}
            />
          </Grid>
          <Grid lg={6}>
            <DatePicker
              label='to'
              views={['month', 'day', 'year']}
              value={filterForm?.date_to}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='To' size='small' fullWidth />}
              onChange={(newValue) => handleChangeDate(newValue, 'date_to')}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleExport}>Submit</Button>
        <Button onClick={handleCancel}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
